// Simulated neighbors for local development (npm run seed).
// These accounts exist only in the local Supabase stack.

export const DEV_PASSWORD = 'roadrunner-dev';

export interface DevNeighbor {
  key: string;
  email: string;
  name: string;
  bio: string;
  lat: number;
  lng: number;
  /** What this account demonstrates, shown in the dev sign-in panel. */
  note: string;
  role?: 'moderator' | 'admin';
}

const HOME = { lat: 32.502, lng: -110.923 }; // Catalina
const MILE_LAT = 1.609 / 111;
const MILE_LNG = 1.609 / 93.9;

export const DEV_NEIGHBORS: readonly DevNeighbor[] = [
  {
    key: 'A',
    email: 'ana@catalina.test',
    name: 'Ana Morales',
    bio: 'Two dogs, one very loud rooster. Happy to lend tools.',
    ...HOME,
    note: 'Catalina (home base)',
  },
  {
    key: 'B',
    email: 'ben@catalina.test',
    name: 'Ben Whitaker',
    bio: 'Retired teacher. I walk the wash every morning.',
    lat: HOME.lat + 0.5 * MILE_LAT,
    lng: HOME.lng,
    note: '0.5 mi north of A: nearly the same board',
  },
  {
    key: 'E',
    email: 'eli@catalina.test',
    name: 'Eli Tsosie',
    bio: '',
    lat: HOME.lat,
    lng: HOME.lng + 1 * MILE_LNG,
    note: '1 mi east of A: nearly the same board',
  },
  {
    key: 'C',
    email: 'cruz@vistoso.test',
    name: 'Cruz Delgado',
    bio: 'New to the area. Looking for good hikes.',
    lat: HOME.lat - 2 * MILE_LAT,
    lng: HOME.lng,
    note: '2 mi south of A (Rancho Vistoso): overlapping board',
  },
  {
    key: 'D',
    email: 'dee@orovalley.test',
    name: 'Dee Harper',
    bio: 'Oro Valley since 1998.',
    lat: 32.3909,
    lng: -110.9665,
    note: 'Oro Valley, 8 mi from A: separate board',
  },
  {
    key: 'S',
    email: 'sam@saddlebrooke.test',
    name: 'Sam Okafor',
    bio: 'Golf cart mechanic by hobby. SaddleBrooke since 2015.',
    lat: 32.5345,
    lng: -110.887,
    note: 'SaddleBrooke, 2.8 mi from A: shares a board with Catalina',
  },
  {
    key: 'O',
    email: 'olive@oracle.test',
    name: 'Olive Brandt',
    bio: 'Up the hill in Oracle.',
    lat: 32.6109,
    lng: -110.7709,
    note: 'Oracle, 11 mi from A: its own board',
  },
  {
    key: 'R',
    email: 'rosa@catalina.test',
    name: 'Rosa Quintero',
    bio: 'Keeping the board friendly.',
    lat: HOME.lat + 0.2 * MILE_LAT,
    lng: HOME.lng - 0.3 * MILE_LNG,
    note: 'Admin, lives near A',
    role: 'admin',
  },
];
